import React from 'react';
import Header from '../components/Layout/Header';

const SettingsPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header title="Settings" subtitle="System configuration" />
      <div className="max-w-4xl mx-auto p-6">
        <h1 className="text-2xl font-bold text-gray-900 mb-2">Settings</h1>
        <p className="text-gray-500 text-sm">System settings are managed by the administrator.</p>
      </div>
    </div>
  );
};

export default SettingsPage;
